import { render, staticRenderFns } from "./RapportForm.vue?vue&type=template&id=2b0f88be&scoped=true&"
import script from "./RapportForm.vue?vue&type=script&lang=js&"
export * from "./RapportForm.vue?vue&type=script&lang=js&"
import style0 from "./RapportForm.vue?vue&type=style&index=0&id=2b0f88be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f88be",
  null
  
)

export default component.exports